import { Suspense, useContext, useEffect } from "react";
import Footer from "../components/layout/Footer";
import Header from "../components/layout/Header";
import ReduxProvider from "../store/redux-provider";
import { myFallback } from "../libs/constant/Constant";
import { Outlet, useNavigate } from "react-router-dom";
import { getLocalStorage } from "../services/localSessionService";
import Loader from "../components/common/Loader";
import { WinContext } from "@/context/WindowFramProvier";
import { windowType } from "@/constants/Category";

export default function Applayout() {
  const router = useNavigate();

  const { app } = useContext(WinContext);

  useEffect(() => {
    if (!getLocalStorage("isLogin") || !getLocalStorage("accessToken")) {
      router("/");
      return;
    }
  }, [router]);

  return (
    <>
      {getLocalStorage("isLogin") && getLocalStorage("accessToken") ? (
        <ReduxProvider>
          <Header></Header>
          <div className={(app === windowType ? "h-[calc(100vh-140px)]" : "h-[calc(100vh-100px)]") + " mx-auto bg-gray-50 sm:px-6 lg:px-8 p-6 overflow-y-auto overflow-x-hidden"}>
            <Suspense fallback={myFallback}>
              <Outlet />
            </Suspense>
          </div>
          <Footer></Footer>
        </ReduxProvider>
      ) : (
        <div>
          <div className="h-screen flex items-center justify-center">
            <div className="text-center">
              <Loader></Loader>
              <div className="my-6">Wait, We are checking credetials...</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
